import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonLibService } from '@lib/services';
import { CheckinBaseComponent } from '@common/components';
import { CHECKIN_ROUTES } from '@conf/routes.config';
import { GetStandbyTravelersResultStoreService } from '@common/services/get-standby-travelers-result-store/get-standby-travelers-result-store.service';
import { GetFlightsResultStoreService } from '@common/services';
import { PREVIOUS_PAGE_IDENTIFIER } from '@conf/previous-page-identifier.config';
import { CheckinCommonStoreService } from '@common/services/checkin-common-store/checkin-common-store.service';
@Component({
  selector: 'asw-checkin-waiting-number-sub-header',
  templateUrl: './checkin-waiting-number-sub-header.component.html',
  styleUrls: ['./checkin-waiting-number-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [GetFlightsResultStoreService, GetStandbyTravelersResultStoreService],
})
export class CheckinWaitingNumberSubHeaderComponent extends CheckinBaseComponent {
  /** 戻り先URL */
  backUrl = '';

  constructor(
    private common: CommonLibService,
    private getStandbyTravelersResultStoreService: GetStandbyTravelersResultStoreService,
    private checkinCommonStoreService: CheckinCommonStoreService
  ) {
    super(common);
  }

  override reload(): void {}
  override init(): void {
    this.backUrl = CHECKIN_ROUTES.waitingSearch;
  }

  /**
   * 戻るボタン押下イベント
   * @param event
   */
  onClickBackButton(event: Event) {
    this.checkinCommonStoreService.updateCheckinCommon({
      previousPageIdentifier: PREVIOUS_PAGE_IDENTIFIER.CHECKIN_WAITING_NUMBER,
    });
    this.getStandbyTravelersResultStoreService.clear();
  }

  override destroy(): void {}
}
